"use client"

import { type UseCaseCategory, categoryLabels, useCases } from "@/app/(marketing)/use-cases/_data/use-cases"
import { type Language, t } from "@/app/(marketing)/use-cases/_lib/i18n"

const activeCategories = [...new Set(useCases.map((uc) => uc.category))] as UseCaseCategory[]

export function CategorySidebar({
  language,
  selectedCategory,
  onSelect,
}: {
  language: Language
  selectedCategory: UseCaseCategory | null
  onSelect: (cat: UseCaseCategory | null) => void
}) {
  return (
    <aside className="hidden lg:block w-48 flex-shrink-0 overflow-hidden">
      <div className="sticky top-[70px]">
        <nav className="space-y-1">
          <button
            onClick={() => onSelect(null)}
            className={`block w-full text-left px-3 py-1.5 rounded-lg text-sm transition-colors ${
              selectedCategory === null ? "bg-gray-100 font-medium" : "hover:bg-gray-50"
            }`}
            style={{ color: "#26251f" }}
          >
            {t(language, "すべて", "All", "全部")}
            <span className="ml-1 text-xs" style={{ color: "#999" }}>
              {useCases.length}
            </span>
          </button>
          {activeCategories.map((cat) => {
            const label = categoryLabels[cat]
            const count = useCases.filter((uc) => uc.category === cat).length
            return (
              <button
                key={cat}
                onClick={() => onSelect(selectedCategory === cat ? null : cat)}
                className={`block w-full text-left px-3 py-1.5 rounded-lg text-sm transition-colors ${
                  selectedCategory === cat ? "bg-gray-100 font-medium" : "hover:bg-gray-50"
                }`}
                style={{ color: "#26251f" }}
              >
                {t(language, label.ja, label.en, label.zh)}
                <span className="ml-1 text-xs" style={{ color: "#999" }}>
                  {count}
                </span>
              </button>
            )
          })}
        </nav>
      </div>
    </aside>
  )
}

export function MobileFilterPills({
  language,
  selectedCategory,
  onSelect,
}: {
  language: Language
  selectedCategory: UseCaseCategory | null
  onSelect: (cat: UseCaseCategory | null) => void
}) {
  return (
    <div className="flex flex-wrap gap-2 mb-6">
      <button
        onClick={() => onSelect(null)}
        className={`px-3 py-1.5 rounded-full text-sm transition-all ${
          selectedCategory === null ? "bg-black text-white" : "bg-gray-100 hover:bg-gray-200"
        }`}
        style={selectedCategory !== null ? { color: "#26251f" } : undefined}
      >
        {t(language, "すべて", "All", "全部")}
      </button>
      {activeCategories.map((cat) => {
        const label = categoryLabels[cat]
        return (
          <button
            key={cat}
            onClick={() => onSelect(selectedCategory === cat ? null : cat)}
            className={`px-3 py-1.5 rounded-full text-sm transition-all ${
              selectedCategory === cat ? "bg-black text-white" : "bg-gray-100 hover:bg-gray-200"
            }`}
            style={selectedCategory !== cat ? { color: "#26251f" } : undefined}
          >
            {t(language, label.ja, label.en, label.zh)}
          </button>
        )
      })}
    </div>
  )
}
